import React, { useMemo } from 'react';
import { BlobProvider } from '@react-pdf/renderer';
import { isFirefox } from 'react-device-detect';

import { ReactComponent as Logo } from '../../assets/logo.svg';
import * as S from './styles';
import { InvoiceActions } from './InvoiceActions';
import { BillingStandardLayout } from './BillingStandardLayout';
import { BillingDetailedLayout } from './BillingDetailedLayout';
import { PdfInvoice } from '../Pdf/PdfInvoice';

/**
 * Billing component router
 * Selects layout based on invoiceTemplate version:
 * - Standard (default): Simple layout with main categories only
 * - Detailed (id: '2'): Enhanced layout with detailed categories
 */
export const Billing = ({ dataBilling }) => {
  // Determine which layout to use based on invoiceTemplate
  const invoiceTemplate = dataBilling?.balance?.invoiceTemplate;
  const isDetailed = invoiceTemplate?.id === '2';

  const invoiceElement = useMemo(() => {
    if (!dataBilling) return null;
    return <PdfInvoice dataBilling={dataBilling} />;
  }, [dataBilling]);

  if (!dataBilling) return null;

  const renderContent = (pdfProps = {}) => (
    <S.Main>
      <S.ContainerHeader>
        <S.ContainerLogo>
          <Logo />
        </S.ContainerLogo>
        <InvoiceActions 
          dataBilling={dataBilling} 
          {...pdfProps}
        />
      </S.ContainerHeader>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {isDetailed ? (
          <BillingDetailedLayout 
            dataBilling={dataBilling} 
            {...pdfProps}
          />
        ) : (
          <BillingStandardLayout 
            dataBilling={dataBilling} 
            {...pdfProps}
          />
        )}
      </div>
    </S.Main>
  );

  if (isFirefox) {
    return renderContent();
  }

  return (
    <BlobProvider document={invoiceElement}>
      {({ url, loading, error }) => {
        if (error) console.error('Global PDF generation error:', error);
        return renderContent({ 
          pdfUrl: url, 
          pdfLoading: loading, 
          pdfError: error 
        });
      }}
    </BlobProvider>
  );
};
